import prepareAssertions from '~/packages/variable/prepareAssertions.util'
import { Variable } from '~/packages/variable/variables.typing'
import { defineAction, number, object, string } from '~/prix'
import monitorProductMetricStatsAction from './monitorProductMetricStats.action.json' with { type: 'json' }
import { childrenType, spaceForPoint } from '~/prix/types/presets/space'
import { timeForIncidence } from '~/prix/types/presets/time'
import { select } from '~/prix/types/presets/select'
import { variable } from '~/prix/types/presets/variable'
import { assertions } from '~/prix/types/presets/assertions'
import { analysis } from '~/prix/types/presets/analysis'
import prefixProperties from '~/prix/utils/prefixProperties'
import expression from '~/prix/types/expression'
import getRecommendedCacheOptions from '~/utils/server/stats/getRecommendedCacheOptions'
import productMetricMonitor from '~/packages/legalEntityGeoprocessing/map/monitor/productMetric.entity'
import { defaultDetectionLayers } from '~/utils/server/stats/defaultTimeSeriesLayers'

const combinedShape = object({
  ...prefixProperties('productMetric.', productMetricMonitor.schema.shape),
})

const monitorProductMetricStatsExpression = expression(combinedShape.shape)

export const monitorProductMetricStatsVariable: Variable = {
  key: 'productMetric',
  categoryKey: 'monitor',
  categoryKeys: ['monitor'],
  actionDefinitionKey: monitorProductMetricStatsAction.key,
  aggregationMode: 'sum',
  title: 'Todos os produtos',
  unitSingular: 'atendimento',
  unitPlural: 'atendimentos',
  grammaticalGender: 'male',
  timeType: 'incidence',
  shape: combinedShape,
  betterDensity: 'more',
  valueRules: {
    minValue: 0,
  },
  customValue: {
    type: 'expression',
    kind: 'function',
    name: 'sum',
    arguments: [
      {
        type: 'expression',
        kind: 'property',
        property: 'productMetric.value',
      },
    ],
  },
  relevance: 0.9,
  basicSelect: ['productMetric.date', 'productMetric.productDescription'],
  detailedSelect: [],
  timeSeries: {
    model: 'additive',
    fitDays: 365 * 10,
    layers: [
      ...defaultDetectionLayers,

      // Camadas de composição
      { layer: 'calendarSeasonality', type: 'year', degree: 1 },
      {
        layer: 'calendarSeasonality',
        type: 'dayOfWeek',
        degree: 1,
        optimization: {
          minimumDays: 60,
          lossFunction: 'recentWeightedMeanSquaredError',
        },
      },
      { layer: 'calendarSeasonality', type: 'monthOfYear', degree: 0 },
      { layer: 'trend', degree: 1 },
      { layer: 'calendarSeasonality', type: 'holiday', degree: 1 },
      { layer: 'calendarSeasonality', type: 'dayOfMonth', degree: 1 },
      { layer: 'trend', degree: 2 },
    ],
  },
  assertions: prepareAssertions(monitorProductMetricStatsExpression),
  compatibleChildrenTypes: ['country', 'macroRegion', 'state'],
}

const monitorProductMetricStatsDefinition = defineAction({
  ...monitorProductMetricStatsAction,
  input: object({
    variable,
    highlight: monitorProductMetricStatsExpression.isOptional(),
    filter: monitorProductMetricStatsExpression.isOptional(),
    space: spaceForPoint().isOptional(),
    time: timeForIncidence().isOptional(),
    select: select(combinedShape),
    assertions,
    analysis,
  }),
  output: object({
    items: object({
      value: number(),
      geoId: string().isOptional(),
      geoType: childrenType.isOptional(),
      dateTime: string().isOptional(),
    }),
  }),
  cache: getRecommendedCacheOptions,
})

export default monitorProductMetricStatsDefinition
